<template>
  <NuxtLink noPrefetch to="/"><img src="/assets/img/logo.svg" alt="Логотип" /></NuxtLink>
</template>
